import { createEvent, createStore } from 'effector';
import type { ReactNode } from 'react';

import type { DialogProps } from '@mui/material';
import type { ButtonOwnProps } from '@mui/material/Button/Button';

export type ConfirmDialogState = {
  readonly title?: string;
  readonly message: ReactNode;
  readonly onClose?: () => void;
  readonly onConfirm?: () => boolean | Promise<boolean>;
  readonly buttonClose?: ButtonOwnProps & { text?: string };
  readonly buttonConfirm?: ButtonOwnProps & { text?: string };
  readonly dialogProps?: Partial<DialogProps>;
  readonly disableCloseWithoutConfirm?: boolean;
};

export const setConfirmDialog = createEvent<ConfirmDialogState | null>();
export const hideConfirmDialog = createEvent();

export const $confirmDialog = createStore<ConfirmDialogState | null>(null);

$confirmDialog
  .on(setConfirmDialog, (_, payload) => {
    return payload;
  })
  .reset(hideConfirmDialog);
